import { render, staticRenderFns } from "./CountryAnalysis.vue?vue&type=template&id=3067cf1e&scoped=true"
import script from "./CountryAnalysis.vue?vue&type=script&lang=js"
export * from "./CountryAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3067cf1e",
  null
  
)

export default component.exports